import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import TransactionContext from '@/product/context/transaction/transactionContext'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { useFormik } from 'formik'
import ReportContext from '@/product/context/report/reportContext'
import { Button } from '@mui/material'
import { handleRedirectInternal } from '../../custom/common/components'
import { useHistory } from 'react-router-dom'
import SellerPayoutContext from '@/product/context/sellerPayout/sellerPayoutContext'

const Transaction = (props) => {
    const reportContext = useContext(ReportContext)
    const sellerPayoutContext = useContext(SellerPayoutContext)
    const [isLoading, setIsLoading] = useState(true)
    const { getAllTransaction, all_trans } = sellerPayoutContext

    let action =
        props.match.params.action !== 'all' ? props.match.params.action : null
    const { getAllExportDownload } = reportContext

    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'spl.invoice_id',
                },
                fromdate: {
                    value: '',
                    type: 'dategreaterequal',
                    field: 'spr.created_at',
                },
                todate: {
                    value: '',
                    type: 'datesmallerequal',
                    field: 'spr.created_at',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllTransaction(values)
        },
    })
    const history = useHistory()
    const onClickEdit = (id, secondaryID, type) => {
        handleRedirectInternal(
            history,
            `invoice/view/paid/${id}/${secondaryID}`
        )
    }

    const onClickViewNew = (id, sid, type) => {
        window.open(
            `${location.origin}/invoice/view/paid/${id}/${sid}`,
            '_blank',
            'noopener,noreferrer'
        )
        // toggleFullScreenPopup(true, type, id, sid)
    }

    useEffect(() => {
        if (all_trans) {
            setTableBody(all_trans.records.length ? all_trans.records : [])
        }
        setIsLoading(false)
    }, [all_trans])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        formik.values.filters.searchterm.value = ''

        getAllTransaction(formik.values)
        /* return () => {
            setTableBody([])
        }*/
    }, [action])

    const tableValues = [
        {
            field: 'seller_payout_logs_invoice_id',
            type: 'hyperlink',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Invoice ID',
            click: true,
            onclick: onClickViewNew,
            clickID: 'seller_payout_logs_invoice_id',
            secondaryClickID: 'buyer_id',
            filterable: true,
            filterField: 'spl.invoice_id',
        },
        {
            field: 'seller_payout_logs_project_id',
            type: 'text',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Product ID',
            click: true,
            onclick: onClickEdit,
            clickID: 'seller_payout_logs_project_id',
            secondaryClickID: 'buyer_id',
            filterable: true,
            filterField: 'spl.project_id',
        },
        {
            field: 'transfer_id',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Transaction ID',
            filterable: true,
            filterField: 'spr.transfer_id',
        },
        {
            field: 'amount',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Amount',
            filterable: true,
            filterField: 'spr.amount',
        },
        // {
        //     field: 'amount_reversed',
        //     type: 'price',
        //     sort: true,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'Amount Reversed',
        //     filterable: true,
        //     filterField: 'spr.amount_reversed',
        // },
        {
            field: 'source_type',
            type: 'capitalize',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Payment Method',
            filterable: true,
            filterField: 'spr.source_type',
        },
        {
            field: 'balance_transaction',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Balance Transaction',
            filterable: true,
            filterField: 'spr.balance_transaction',
        },
        {
            field: 'as_employees_emp_firstname',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Seller First Name',
            filterable: true,
            filterField: 'e.emp_firstname',
        },
        {
            field: 'as_employees_emp_lastname',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Seller Last Name',
            filterable: true,
            filterField: 'e.emp_lastname',
        },
        {
            field: 'as_employees_emp_email',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Seller Email',
            filterable: true,
            filterField: 'e.emp_email',
        },
        {
            field: 'created_at',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Created Date',
        },
        {
            field: 'status',
            type: 'capitalize',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        },
    ]

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Invoice Number',
                placeholder: 'Enter invoice number',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
                filter: true,
            },
            {
                label: 'Created From Date',
                placeholder: 'Date Ending from',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'fromdate',
                filter: true,
            },
            {
                label: 'Created To Date',
                placeholder: 'Date Ending To',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'todate',
                filter: true,
            },
        ],
    }

    const resetForm = () => {
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        formik.values.filters.searchterm.value = ''
        getAllTransaction(formik.values)
    }

    const tableActions = []

    return (
        <Layout>
            <div className="dashboard invoice">
                <CustomSearch
                    searchInfo={searchInfo}
                    formik={formik}
                    advFilters={true}
                    resetForm={resetForm}
                />
                {/* <Button
                    id="transaction_report"
                    onClick={() =>
                        getAllExportDownload({
                            action: 'export',
                            order: 'asc',
                            orderby: '',
                            search: 'all',
                            report: `transaction_list`,
                        })
                    }
                >
                    <span className="material-icons">get_app</span>Export All
                    Data
                </Button> */}
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={all_trans}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllTransaction}
                />
            </div>
        </Layout>
    )
}

export default Transaction
